import RestrictionContainer from './RestrictionContainer';

export default RestrictionContainer;
